// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyDZ_ngOdflQ6tmuho-f5oe_UQwICvMehog',
  authDomain: 'chatroom-cdcbe.firebaseapp.com',
  databaseURL: 'https://chatroom-cdcbe-default-rtdb.firebaseio.com',
  projectId: 'chatroom-cdcbe',
  storageBucket: 'chatroom-cdcbe.appspot.com',
  messagingSenderId: '895860045363',
  appId: '1:895860045363:web:791f129343005a0b681546',
  measurementId: 'G-14VXWB96ZE',
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)
export const auth = getAuth()
export const storage = getStorage()
export const db = getFirestore(app)
